import type { IAudienceTemplate } from '@/Interfaces/AudienceTemplates/AudienceTemplate.interface';
import { createSlice } from '@reduxjs/toolkit';
import {
  createAudienceTemplate,
  deleteAudienceTemplate,
  getAudienceTemplates,
  updateAudienceTemplate,
} from './audienceTemplates.thunks';

interface IAudienceTemplatesState {
  templates: IAudienceTemplate[];
  loading: boolean;
  saving: boolean;
}

const initialState: IAudienceTemplatesState = {
  templates: [],
  loading: false,
  saving: false,
};

export const audienceTemplatesSlice = createSlice({
  name: 'audienceTemplates',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAudienceTemplates.pending, state => {
        state.loading = true;
      })
      .addCase(getAudienceTemplates.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.templates = payload;
      })
      .addCase(getAudienceTemplates.rejected, state => {
        state.loading = false;
      })
      .addCase(createAudienceTemplate.pending, state => {
        state.saving = true;
      })
      .addCase(createAudienceTemplate.fulfilled, (state, { payload }) => {
        state.saving = false;
        state.templates.push(payload);
      })
      .addCase(createAudienceTemplate.rejected, state => {
        state.saving = false;
      })
      .addCase(updateAudienceTemplate.pending, state => {
        state.saving = true;
      })
      .addCase(updateAudienceTemplate.fulfilled, (state, { payload }) => {
        state.saving = false;
        state.templates = state.templates.map(template => (template.id === payload.id ? payload : template));
      })
      .addCase(updateAudienceTemplate.rejected, state => {
        state.saving = false;
      })
      .addCase(deleteAudienceTemplate.fulfilled, (state, { payload: id }) => {
        state.templates = state.templates.filter(template => template.id !== id);
      });
  },
});

export default audienceTemplatesSlice.reducer;
